var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"external-container"},[_c('div',{class:_vm.className,on:{"click":_vm.scrollToTarget}}),_c('b',{staticClass:"txt"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }